module.exports = __webpack_public_path__ + "static/2_3-tic-tac-toe-77c7908ca1950d2176b6d9c0660ffebd.svg";